(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-bow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('holiday-bow')) {
    customElements.define('holiday-bow', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.dataset.motion !== 'true') return;
        this.trigger = this.querySelector('.wt-bow__trigger');
        this.bendX = this.querySelector('.wt-bow__bend-x');
        this.bendY = this.querySelector('.wt-bow__bend-y');
        if (!this.trigger || !this.bendX || !this.bendY) return;
        this.current = { x: 0, y: 0 };
        this.target = { x: 0, y: 0 };
        this.frame = 0;
        this.lastTime = 0;
        this.pointerActive = false;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.tick = time => {
          const elapsed = Math.min(time - (this.lastTime || time - 16), 50);
          this.lastTime = time;
          const easing = 1 - Math.exp(-elapsed / 260);
          this.current.x += (this.target.x - this.current.x) * easing;
          this.current.y += (this.target.y - this.current.y) * easing;
          const settled = Math.abs(this.target.x - this.current.x) < .02 && Math.abs(this.target.y - this.current.y) < .02;
          if (settled) this.current = { ...this.target };
          this.bendX.setAttribute('scale', this.current.x.toFixed(3));
          this.bendY.setAttribute('scale', this.current.y.toFixed(3));
          this.frame = settled ? 0 : requestAnimationFrame(this.tick);
          if (settled) this.lastTime = 0;
        };
        const follow = event => {
          if (event.pointerType !== 'mouse' && !this.pointerActive) return;
          const bounds = this.trigger.getBoundingClientRect();
          const x = Math.max(-1, Math.min(1, ((event.clientX - bounds.left) / bounds.width - .5) * 2));
          const y = Math.max(-1, Math.min(1, ((event.clientY - bounds.top) / bounds.height - .315) * 1.5));
          this.move(x * 36, y * 22);
        };
        this.trigger.addEventListener('pointermove', follow, options);
        this.trigger.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') follow(event);
        }, options);
        this.trigger.addEventListener('pointerdown', event => {
          this.pointerActive = true;
          follow(event);
        }, options);
        const release = () => {
          this.pointerActive = false;
          this.move(0, 0);
        };
        this.trigger.addEventListener('pointerleave', release, options);
        this.trigger.addEventListener('pointercancel', release, options);
        window.addEventListener('pointerup', event => {
          if (event.pointerType !== 'mouse') release();
        }, options);
        this.trigger.addEventListener('focus', () => {
          if (this.trigger.matches(':focus-visible')) this.move(11, -5);
        }, options);
        this.trigger.addEventListener('blur', release, options);
        this.trigger.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.move(18, -7);
          }
        }, options);
        this.trigger.addEventListener('keyup', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.move(11, -5);
          }
        }, options);
        this.reduced.addEventListener('change', () => {
          if (this.reduced.matches) this.stop();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
        }, options);
      }
      move(x, y) {
        if (this.reduced?.matches) return;
        this.target = { x, y };
        if (!this.frame) this.frame = requestAnimationFrame(this.tick);
      }
      stop() {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.lastTime = 0;
        this.current = { x: 0, y: 0 };
        this.target = { x: 0, y: 0 };
        this.bendX?.setAttribute('scale', '0');
        this.bendY?.setAttribute('scale', '0');
      }
      disconnectedCallback() {
        this.stop();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
